export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5642.1e33ca27.jpg";